import { useEffect, useState } from "react";
import { fetchInsurerConsumption, type InsurerConsumption } from "../api/claimsApi";

/** Consommation des bénéficiaires et des familles de l'assureur. */
export function useInsurerConsumption() {
  const [data, setData] = useState<InsurerConsumption>({ people: [], families: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchInsurerConsumption()
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : "Impossible de charger les assurés."))
      .finally(() => setLoading(false));
  }, []);

  return { ...data, loading, error };
}
